<ng-container *ngFor="let contentControl of data">
  <ui-content-display-item [contentControl]="contentControl"></ui-content-display-item>
</ng-container>

<ng-content select="[custom-content-section]"></ng-content>
